import React, {useState , useEffect, useRef} from 'react'

import { Image, Grid, GridColumn, GridRow,Search as SearchSU ,Icon, Container ,Segment, Button } from 'semantic-ui-react';
import {result, size, map, set} from "lodash"
import { useQuery } from '@apollo/client';
import { Link } from 'react-router-dom';
import icona from "./../../../asets/png/icona.jpg";

import { SEARCH_PUBLICATION } from '../../../gql/publication';
import Footer from '../Footer/Footer';

import buscar from "../../../asets/png/buscar.png"
import celular from "../../../asets/png/celular .jpg"
import tienda from "../../../asets/png/tienda .jpg"


import "./BuscarEx.scss";



export default function BuscarEx() {
  const [search , setSearch] = useState (null);
   const [results, setResults]= useState ([]);
   const [datos, setDatos]= useState([]);
   
   const inputRef = useRef ({});
   const {data, loading} = useQuery (SEARCH_PUBLICATION, {
      variables:{search}

   });
   
   

  const onChange = (e) => { if (e.target.value) setSearch (e.target.value);
  else setSearch(null);
}




useEffect(() => {
  if (size(data?.searchPubli ) > 0){
   
    const publics = [];

   
    
    data.searchPubli.forEach((publi) => {
      publics.push({
          

          file:publi.file,
          title:publi.title,
          descripcion:publi.description,
          area:publi.area,
          
          ident:publi._id,
          
         

       } );
      



    });

    


     setResults (publics);
     
 

  }else{
     setResults([]);
     console.log("error")
  }
},[data]);



   
 

    
    
 
 
 
 
 
 
   return (


<>
    <Grid className='buscarex' mobile = {5} computer={10} centered>
      
    <GridRow>
     
    </GridRow>
   
     
     <SearchSU  className="searchpubli"
                fluid
                input={{ icon: "search", iconPosition: "left" }}
                loading = {loading}
                
                onSearchChange = {onChange}
                value = {search || ""}
                results = {results}
                resultRenderer={(e) => < ResultSearch data ={e}   />}
                mobile = {16}
     />



        
<div className='buscar '   mobile={5}  computer={10}  centered  >
       
       
<Image  src={buscar}   size ='tiny' />
<Image  src={buscar}   size ='small' />
<Image  src={buscar}   size ='tiny' />

</div>


       
     

</Grid>



<h2>Buscar en la colme  </h2>
 

<Grid width={16} mobile={16}>
<GridColumn width={8}  mobile={8}  className= "catego">
          <Segment attached='top' className= "boton"   >
            <span >Explora por categoría de artículos ..⭐</span>
            <Image centered src= {tienda} />
          </Segment>
          <Link to = "/category">
          <Button attached='top' content='Categorias' color='teal' /> 
        </Link>
        </GridColumn>
        <GridColumn width={8}  mobile={8} className= " catego" >
          <Segment attached='top' className= "boton"   >
            <span >Encuentra artículos a precio de liquidación y de única oportunidad ..⭐</span>
            <Image centered src= {celular} />
          </Segment>
          <Link to = "/category/Ofertas">
          <Button attached='top' content='Ofertas' color='red' /> 
        </Link>

</GridColumn>



<GridColumn centered computer={16} mobile= {16}>

<Footer/>
</GridColumn>

      </Grid>


    </>
   );

}

 
 
  function ResultSearch (props) {
    const [showModal, setShowModal] = useState (false);
    const [titleModal, setTitleModal] = useState ("")
    const [publicationSelect, setPublicationSelect ] = useState (null);
   const [childrenModal, setChildrenModal] = useState (null) 
   
     const {data , dato} = props;

     console.log ( "datos",data );

     
      return(
        <div  className='resul'>

    <Link to = {`/Publication/${data.ident}`}>   
    <Image tiny src = {data.file} />
    </Link>

    <Link to = {`/Publication/${data.ident}`}>   
    <p> {data.title}  </p>

    <p> {data.descripcion}  </p>

    </Link>
    
    


    <span> <Icon name = "map marker alternate"/> {data.area}  </span>


</div>

) }


 
 
